import { ViewStyle } from 'react-native';

export const LEFT_ARROW_CONTAINER_STYLE: ViewStyle = {
  position: 'absolute',
  left: 0,
  top: '50%',
  marginLeft: 5,
  transform: [{ translateY: -20 }],
  zIndex: 1,
};

export const RIGHT_ARROW_CONTAINER_STYLE: ViewStyle = {
  position: 'absolute',
  right: 0,
  top: '50%',
  marginRight: 5,
  transform: [{ translateY: -20 }],
  zIndex: 1,
};

export const CONTAINER_STYLE: ViewStyle = {
  position: 'relative',
};
